const AuthorPermissions = {
  edit: 'author:edit',
  create: 'author:create',
  delete: 'author:delete',
  view: 'author:view',
}

export default AuthorPermissions
